<template>
  <div class="project" v-if="project" :style="getStyles">
    <navbar absolute is-on-project>
      <li class="narrow">
        <router-link class="navigation-link back-to-nav" to="/"
          >Index</router-link
        >
      </li>
      <li>
        <a
          v-if="project.field_project_url.length"
          target="_blank"
          class="navigation-link project-url"
          :href="project.field_project_url[0].value"
          >Visit Website</a
        >
      </li>
    </navbar>

    <navbar
      absolute
      bottom
      hidden-on-mobile
      is-on-project
      flex-end
      no-pointer-events
      v-if="project.field_slides.length > 1"
    >
      <li>
        <span class="slide-number"
          >{{ currentSlideNumber }} / {{ project.field_slides.length }}</span
        >
      </li>
    </navbar>

    <div class="project-container" @scroll="onprojectContainerScroll">
      <project-slide
        ref="projectSlides"
        v-for="slide in project.field_slides"
        v-bind:slide="slide"
        v-bind:key="slide.uuid[0].value"
      ></project-slide>
      <router-link
        v-if="project.field_slides.length > 1"
        to="/"
        class="back-to-top"
        >BACK ⤶</router-link
      >
    </div>
  </div>
</template>

<script>
import { buildUrl, throttle } from "@/helpers.js";
import ProjectSlide from "@/components/ProjectSlide";
import Navbar from "@/components/Navbar";

export default {
  data() {
    return {
      project: null,
      currentSlideNumber: 1,
      currentSlideIndex: 0,
      viewportHeight: window.innerHeight,
    };
  },

  components: {
    ProjectSlide,
    Navbar,
  },

  computed: {
    getStyles() {
      return {
        "--project-background-color": this.project
          ? this.project.field_background_color[0].value
          : null,
        "--project-text-color": this.project
          ? this.project.field_text_color[0].value
          : null,
      };
    },
  },

  methods: {
    async preloadImages(imagesToPreload) {
      let imageSlides = this.project.field_slides.filter(
        (slide) => slide.type[0].target_id == "image"
      );

      if (imageSlides.length > imagesToPreload) {
        imageSlides = imageSlides.slice(0, imagesToPreload);
      }

      const totalCount = imageSlides.length;
      let loadedCount = 0;

      await Promise.all(
        imageSlides.map((slide) => {
          return new Promise((resolve) => {
            const image = new Image();
            image.src = buildUrl(slide.field_image[0].uri[0].url);
            image.onload = () => {
              loadedCount++;
              this.$Progress.set((loadedCount * 100) / totalCount);
              resolve();
            };
          });
        })
      );
    },
    onprojectContainerScroll: throttle(function (e) {
      this.currentSlideNumber = Math.floor(
        e.target.scrollTop / document.documentElement.clientHeight + 1
      );
    }, 300),
  },

  async mounted() {
    const imagesToPreload = 0;

    const projects = this.$store.state.projects;

    this.project = projects.find(
      (p) => p.field_slug[0].value == this.$route.params.slug
    );

    this.$Progress.set(10);
    if (imagesToPreload) {
      await this.preloadImages(imagesToPreload);
    }
    this.$Progress.finish();

    setTimeout(() => {
      this.$emit("ready");
    }, 700);

    // Prerendering
    // https://github.com/chrisvfritz/prerender-spa-plugin
    document.dispatchEvent(new Event("page-rendered"));
  },

  beforeRouteLeave(to, from, next) {
    this.$emit("before-route-leave", function () {
      next();
    });
  },
};
</script>

<style lang="scss">
@import "@/styles/mixins.scss";

.project {
  height: calc(var(--vh, 1vh) * 100);
  width: 100%;
  box-sizing: border-box;
  background-color: #fff;
  color: #000;

  @include breakpoint(xs) {
    color: var(--project-text-color, #fff);
    background-color: var(--project-background-color, #fff);
  }

  .project-url-mobile {
    display: none;
    @include breakpoint(xs) {
      display: block;
    }
  }

  .slide-number {
    display: block;
    letter-spacing: -1px;
    font-size: 1.15em;
  }

  .project-container {
    height: 100%;
    overflow-y: scroll;

    @include breakpoint(sm) {
      scroll-snap-type: y mandatory;
    }

    .back-to-top {
      display: block;
      letter-spacing: -0.05em;
      scroll-snap-align: end;

      @include breakpoint(xs) {
        font-size: var(--back-to-top-font-size-mobile);
        padding: var(--back-to-top-padding-mobile);
      }

      @include breakpoint(sm) {
        font-size: var(--back-to-top-font-size-tablet);
        padding: var(--back-to-top-padding-tablet);
      }

      @include breakpoint(md) {
        font-size: var(--back-to-top-font-size);
        padding: var(--back-to-top-padding);
      }
    }
  }
}
</style>
